import React, {useState, useEffect} from 'react';
import EmptyGraphic from '../../images/empty-states/empty-notes.png';
import '../../styles/partials/components/_empty-states.scss';
import ReactGA from 'react-ga';
let checkInterval;

const EmptyNotes = () => {
  const [hasExtension, setHasExtension] = useState(false);

  useEffect(() => {
    checkInterval = setInterval(checkInstall, 100);
  });

  const checkInstall = () => {
    const isInstalledNode = document.getElementById('rn_extension-is-installed');

    if (isInstalledNode) {
      setHasExtension(true);
      clearInterval(checkInterval);
    }
  };

  const trackInstallClick = () => {
    ReactGA.event({
      category: 'Onboarding',
      action: 'Clicked Install Link',
    });
  };

  return (
    <div className="empty-placeholder empty-notes">
      <div className="content-container">
        <div className="image-container">
          <img src={EmptyGraphic} alt="No Notes" />
        </div>
        {hasExtension ? (
          <p>You haven't taken any notes yet! Go over to <a href="https://youtube.com" target="_blank">YouTube</a> to get started.</p>
        ) : (
          <p>You'll need to <a href="https://chrome.google.com/webstore/detail/rocket-note/hemjflepggljigpcaneoeldgipbpcbmg?ref=placeholder" target="_blank" onClick={trackInstallClick}>install our Chrome extension</a> to start taking notes on YouTube.</p>
        )}
      </div>
    </div>
  );
};

export default EmptyNotes;
